import React from 'react';
import styled from 'styled-components/macro';
import LayoutWrapper from 'routes/tourOperator/flightCache/comp/utility/layoutWrapper';
import LayoutContent from 'routes/tourOperator/flightCache/comp/utility/layoutContent';
import SwitchMenu from 'routes/tourOperator/flightCache/comp/flightCache/SwitchMenu';
import FlightCalendarsData from './comp/flightCalendarsData';
import FlightCalendarsFilters from './comp/flightCalendarsFilters';

function FlightCalendars() {
  return (
    <LayoutWrapper>
      <LayoutContent>
        <SwitchMenu />
        <Root>
          <FlightCalendarsFilters />
          <FlightCalendarsData />
        </Root>
      </LayoutContent>
    </LayoutWrapper>
  );
}

export default FlightCalendars;

const Root = styled.div`
  display: flex;
  flex-direction: column;

  > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;
